import React from 'react';
import { Alert, Typography } from 'antd';

const { Paragraph, Text } = Typography;

const TerminationSection = () => {
  return (
    <div>
      <Paragraph>
        Either Customer or Club Sports Solutions L.L.C. ("Provider") may terminate
        this Agreement at any time by providing at least thirty (30) days written
        notice to the other party.
      </Paragraph>

      <Paragraph>
        <Text strong>Customer-Initiated Termination</Text>
      </Paragraph>

      <Paragraph>
        Customer may cancel its TrackBiz subscription by providing written notice
        to Provider. Customer remains responsible for all fees incurred prior to
        the effective termination date.
      </Paragraph>

      <Paragraph>
        <Text strong>Provider-Initiated Termination</Text>
      </Paragraph>

      <Paragraph>
        Provider may suspend or terminate Customer's access to TrackBiz if:
      </Paragraph>

      <ul>
        <li>Customer fails to pay fees owed under this Agreement.</li>
        <li>Customer violates the terms of this Agreement.</li>
        <li>Customer uses TrackBiz for unlawful, fraudulent, or unauthorized purposes.</li>
        <li>Customer's use of TrackBiz creates security, legal, or operational risks.</li>
      </ul>

      <Alert
        message="Immediate Suspension"
        description="Provider may immediately suspend access to TrackBiz if necessary to protect the security, integrity, or lawful operation of the platform."
        type="warning"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph>
        Upon termination of this Agreement:
      </Paragraph>

      <ul>
        <li>Customer's right to access and use TrackBiz will immediately end.</li>
        <li>Recurring subscription billing will be discontinued.</li>
        <li>Customer may request a data export as described in the Data Export and Retention section.</li>
        <li>Provider may delete Customer Data in accordance with its data retention policies.</li>
      </ul>

      <Alert
        message="Data Export Reminder"
        description="Customer should request any necessary data exports within thirty (30) days following termination to avoid permanent loss of data."
        type="info"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph>
        Termination of this Agreement will not affect any rights, obligations,
        payment responsibilities, or legal remedies that accrued prior to the
        effective termination date.
      </Paragraph>
    </div>
  );
};

export default TerminationSection;